module.exports = __webpack_public_path__ + "img/logo.fc933228.png";